export type AppLoginStatus
  = "AUTHORIZED"
  | "FETCHING"
  | "FETCH_ERROR"
  | "NOT_LOGGED_IN"
  | "USER_NOT_PERMITTED"
  | "REPO_NOT_PERMITTED"
  | "PENDING_AUTHORIZATION"
  | "WRONG_REPO"
  ;

const initialState: AppLoginStatus = "FETCHING"

export type AppLoginAction = { type: "SET_APP_LOGIN_STATUS", payload: AppLoginStatus }

export default function appLoginReducer(state: AppLoginStatus = initialState, action: AppLoginAction): AppLoginStatus {
  switch (action.type) {
    case "SET_APP_LOGIN_STATUS":
      return action.payload;
  }

  return state
}
